import moment from 'moment';

class DateHelper {
  constructor() {}

  /* Выводит в виде: 18 СЕНТЯБРЯ */
  stampTodm(date) {
    const months = [
      'Января',
      'Февраля',
      'Марта',
      'Апреля',
      'Мая',
      'Июня',
      'Июля',
      'Августа',
      'Сентября',
      'Октября',
      'Ноября',
      'Декабря',
    ];
    const dt = new Date(date * 1000);

    return `${dt.getDate()} ${months[dt.getMonth()]}`;
  }

  /* Выводит в виде: СЕНТЯБРЯ */
  stampTom(date) {
    const months = [
      'Января',
      'Февраля',
      'Марта',
      'Апреля',
      'Мая',
      'Июня',
      'Июля',
      'Августа',
      'Сентября',
      'Октября',
      'Ноября',
      'Декабря',
    ];
    const dt = new Date(date * 1000);

    return months[dt.getMonth()];
  }

  /* Выводит в виде: Понедельник */
  stampToDay(date) {
    const days = [
      'Воскресенье',
      'Понедельник',
      'Вторник',
      'Среда',
      'Четверг',
      'Пятница',
      'Суббота',
    ];
    const dt = new Date(date * 1000);

    return days[dt.getDay()];
  }

  /* Выводит в виде: Пн */
  stampToDayShort(date) {
    const days = [
      'Вс',
      'Пн',
      'Вт',
      'Ср',
      'Чт',
      'Пт',
      'Сб',
    ];
    const dt = new Date(date * 1000);

    return days[dt.getDay()];
  }

  getFormattedDateStr(date, format = 'DD.MM.YYYY HH:mm') {
    if (!date) return '';
    return moment(date, 'YYYY-MM-DD HH:mm:ss').locale(`${document.documentElement.lang}`);
  }

  /* Выводит длительность мероприятия в виде 18:25-19:00 */
  toDurationEvent (date, duration) {
    return `${this.stampToHi(date)}–${this.stampToHi(date+duration)}`;
  }

  /* Выводит в виде: 18:25 */
  stampToHi(date) {
    const dt = new Date(date * 1000);
    const hours = dt.getUTCHours();
    const minutes = dt.getUTCMinutes();

    return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
  }

  getDurationInMinutes(duration) {
    return Math.ceil(duration / 60);
  }
  getFormattedDateStr(date, format = 'DD.MM.YYYY HH:mm') {
    if (!date) return '';
    return moment(date, 'YYYY-MM-DD HH:mm:ss').locale(`${document.documentElement.lang}`);
  }
  toDateInputValue() {
    const local = new Date();
    local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
  }

  /**
   * Функция создает момент из метки времени Unix и возращает в виде строки в заданном формате
   * @param {Number} date
   * @param {String} format
   * @return {String}
   * getFormattedDate(1696086000, "DD.MM.YYYY");
   * 30.09.2023 18:00
   * подробнее о форматах https://momentjs.com/docs/#/displaying/format/
   */
  getFormattedDate(date, format = 'DD.MM.YYYY HH:mm') {
    if (!date) return '';
    return moment.unix(date).locale(`${document.documentElement.lang}`).format(format);
  }

  /**
   * Функция добавляет одиночной цифре 0 в начало
   * Например, 12:8 превратится в 12:08
   * @param {Number} Object
   * @return {Object}
   */
  transformSingleNumberToTwoDigit(timeObject) {
    const formattedProps = {};

    Object.entries(timeObject).forEach(([key, value]) => {
      formattedProps[key] = value < 10 ? `0${value}` : String(value);
    });

    return formattedProps;
  }
}

export const dateHelper = new DateHelper();
